<template>
  <form v-if="loaded" @submit.prevent="submit">
    <div class="row">
      <div class="col-sm-6">
        <base-field label="Title">
          <base-input v-model="payload.title" placeholder="title" />
        </base-field>
      </div>
      <div class="col-sm-6 text-right">

      </div>
      <div class="col-sm-12">
        <base-field label="Content">
          <wysiwyg-editor v-model="payload.content" />
        </base-field>
        <div class="d-flex justify-content-end align-items-center text-right">
          <base-checkbox v-model="payload.published">Published</base-checkbox>
          <base-button class="ml-3" icon-right="arrow-right" primary submit>
            Save Article
          </base-button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import WysiwygEditor from './WysiwygEditor.vue'

export default {
  async created () {
    if (this.edit) {
      await this.$store.dispatch('core/support-articles/get', this.edit)

      this.editing = true
      this.payload = this.$_.cloneDeep(this.supportArticle)
    } else {
      this.payload = this.$_.cloneDeep(this.schema)
    }

    this.loaded = true
  },

  data () {
    return {
      editing: false,
      loaded: false,
      payload: {},
      saving: false
    }
  },

  name: 'SupportArticleEditor',

  components: {
    WysiwygEditor
  },

  props: {
    edit: String
  },

  computed: {
    ...mapGetters({
      schema: 'core/support-articles/schema'
    }),

    ...mapState({
      supportArticle: store => store.core.supportArticles.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true

      await this.$store.dispatch('core/support-articles/save', this.payload)

      this.saving = false

      this.$flash.success('Article successfully saved')

      this.$emit('saved', this.$_.cloneDeep(this.supportArticle))
    }
  }
}
</script>
